/* SÃDE — recipe detail renderer for the extended set (25–45).
   Data comes from window.SX, populated by sade-recipe-data-1/2.js
   assets/sade-recipe.js (recipes 01–24) is left untouched. */
const DATA = (window.SX || {});
const PEERS = {"ube-latte":[1,"drinks","Ube <em>Latte.</em>","5 min"],"iced-ube-matcha":[2,"drinks","Iced ube <em>matcha.</em>","6 min"],"ube-horchata":[3,"drinks","Ube <em>horchata.</em>","+ soak"],"ube-halaya-smoothie":[4,"drinks","Ube halaya <em>smoothie.</em>","4 min"],"ube-smoothie-bowl":[5,"drinks","Ube <em>smoothie bowl.</em>","10 min"],"ube-hot-chocolate":[6,"drinks","Ube hot <em>chocolate.</em>","7 min"],"ube-halaya":[7,"sweet","Ube <em>halaya.</em>","40 min"],"ube-overnight-oats":[8,"sweet","Ube <em>overnight oats.</em>","Overnight"],"ube-pancakes":[9,"sweet","Ube <em>pancakes.</em>","15 min"],"ube-crinkle-cookies":[10,"sweet","Ube crinkle <em>cookies.</em>","35 min"],"no-bake-ube-cheesecake":[11,"sweet","No-bake ube <em>cheesecake.</em>","45 min"],"ube-cinnamon-rolls":[12,"sweet","Ube cinnamon <em>rolls.</em>","+ prove"],"ube-ice-cream":[13,"sweet","Ube <em>ice cream.</em>","4 hrs"]};
const CAT_LABEL = {"drinks":"Drinks","sweet":"Something sweet","savoury":"Something savoury","local":"Local twist"};
const GRAD = {
  drinks:"radial-gradient(ellipse at 40% 30%, rgba(237,229,245,0.4), transparent 55%),linear-gradient(180deg,#EDE5F5 0%,#C8AEE8 45%,#4B2D6B 100%)",
  sweet:"radial-gradient(ellipse at 40% 30%, rgba(237,229,245,0.45), transparent 55%),linear-gradient(180deg,#C8AEE8 0%,#6B4D8A 50%,#3A1F54 100%)",
  savoury:"radial-gradient(ellipse at 40% 30%, rgba(235,229,208,0.4), transparent 55%),linear-gradient(180deg,#8B6F4A 0%,#5A4A30 45%,#3A1F54 100%)",
  local:"radial-gradient(ellipse at 40% 30%, rgba(235,229,208,0.45), transparent 55%),linear-gradient(180deg,#EBE5D0 0%,#B89B6A 38%,#3A1F54 100%)"
};
function plainTitle(html){ return html.replace(/<[^>]+>/g,'').replace(/&amp;/g,'&').replace(/\.$/,''); }
function formatQty(val, unit){
  if(unit==='tsp'||unit==='tbsp'||unit===''){
    let r=Math.round(val*4)/4;
    const fmap={0.25:'¼',0.5:'½',0.75:'¾'};
    const whole=Math.floor(r), frac=r-whole;
    let str = whole>0 ? (''+whole) : '';
    if(frac) str = (whole>0?whole+' ':'') + fmap[frac];
    if(r<1) str = fmap[r] || (''+r);
    if(r===0) str='0';
    return unit ? (str+' '+unit) : str;
  }
  if(unit==='g'||unit==='ml') return Math.round(val)+' '+unit;
  if(unit==='pinch'){ if(val<1.5)return 'A pinch'; if(val<2.5)return '2 pinches'; return Math.round(val)+' pinches'; }
  return (Math.round(val*10)/10)+' '+unit;
}
const slug = (window.SADE_RECIPE_SLUG || '');
const r = DATA[slug];
if(r){
  const catLabel = CAT_LABEL[r.cat];
  document.title = plainTitle(r.title) + ' — sãde';
  document.getElementById('bc-cat').textContent = catLabel;
  document.getElementById('bc-name').textContent = plainTitle(r.title);
  document.getElementById('m-num').textContent = 'Recipe ' + String(r.num).padStart(2,'0');
  document.getElementById('m-cat').textContent = catLabel;
  document.getElementById('m-title').innerHTML = r.title;
  document.getElementById('m-intro').textContent = r.intro;
  const heroInner = document.querySelector('.recipe-hero-inner');
  heroInner.style.background = GRAD[r.cat];
  const heroImg = document.getElementById('hero-img');
  var _hs=(window.SADE_IMG||{})[slug]; if(_hs){heroImg.src=_hs;}else{heroImg.remove();}
  document.getElementById('hero-label').textContent = plainTitle(r.title) + ' · serves ' + r.servings;
  document.getElementById('s-prep').textContent = r.prep;
  document.getElementById('s-cook').textContent = r.cook;
  document.getElementById('s-total').textContent = r.total;
  document.getElementById('s-level').textContent = r.level;
  document.getElementById('servings-value').textContent = r.servings;
  const il = document.getElementById('ingredients-list');
  r.ingredients.forEach(it => {
    const [disp, base, unit, label, note, sade] = it;
    const li = document.createElement('li');
    li.className = 'ingredient' + (sade ? ' sade-ingredient' : '');
    li.setAttribute('data-base', base);
    li.innerHTML = '<div class="ingredient-check"></div>' +
      '<div class="ingredient-quantity" data-unit="'+unit+'">'+disp+'</div>' +
      '<div class="ingredient-label">'+(sade?'<em>'+label+'</em>':label)+(note?'<span class="note">'+note+'</span>':'')+'</div>';
    li.addEventListener('click', ()=>li.classList.toggle('checked'));
    il.appendChild(li);
  });
  document.getElementById('ing-count').textContent = r.ingredients.length + ' items';
  const sl = document.getElementById('steps-list');
  r.steps.forEach((st,i) => {
    const [title, body, timing] = st;
    const li = document.createElement('li');
    li.className = 'step';
    li.innerHTML = '<span class="step-number">'+String(i+1).padStart(2,'0')+'</span>' +
      '<div class="step-content"><h3>'+title+'</h3><p>'+body+'</p>'+(timing?'<span class="step-timing">'+timing+'</span>':'')+'</div>';
    li.addEventListener('click', ()=>li.classList.toggle('completed'));
    sl.appendChild(li);
  });
  document.getElementById('step-count').textContent = r.steps.length + ' steps';
  const pg = document.getElementById('pairings-grid');
  r.pairings.forEach(p => {
    const s = document.createElement('span');
    s.className = 'pairing-tag';
    s.textContent = p;
    pg.appendChild(s);
  });
  const rg = document.getElementById('related-grid');
  let rel = Object.keys(DATA).filter(s => s!==slug && DATA[s].cat===r.cat)
              .map(s => [s, DATA[s].num, DATA[s].cat, DATA[s].title, DATA[s].total]);
  Object.keys(PEERS).forEach(s => { if(PEERS[s][1]===r.cat) rel.push([s, PEERS[s][0], PEERS[s][1], PEERS[s][2], PEERS[s][3]]); });
  rel.slice(0,3).forEach(row => {
    const [s, num, cat, title, total] = row;
    const a = document.createElement('a');
    a.className = 'related-card';
    a.href = '/pages/' + s;
    a.setAttribute('data-moment', cat);
    a.innerHTML = '<div class="related-visual" style="background:'+GRAD[cat]+'">' +
        '<img src="'+((window.SADE_IMG||{})[s]||'')+'" alt="" loading="lazy" style="position:absolute;inset:0;width:100%;height:100%;object-fit:cover" onerror="this.remove()">' +
        '<span class="related-badge">'+CAT_LABEL[cat]+'</span></div>' +
      '<h3>'+title+'</h3>' +
      '<div class="meta">Recipe '+String(num).padStart(2,'0')+' · '+total+'</div>';
    rg.appendChild(a);
  });
  const servingsValue=document.getElementById('servings-value');
  const plusBtn=document.getElementById('servings-plus');
  const minusBtn=document.getElementById('servings-minus');
  const BASE=r.servings, MIN=Math.max(1,Math.round(r.servings/3)), MAX=r.servings*4;
  let current=BASE;
  function updateServings(v){
    current=v; servingsValue.textContent=v;
    minusBtn.disabled=v<=MIN; plusBtn.disabled=v>=MAX;
    const mult=v/BASE;
    document.querySelectorAll('.ingredient').forEach(ing=>{
      const b=parseFloat(ing.getAttribute('data-base'));
      if(!(b>0)) return;
      const q=ing.querySelector('.ingredient-quantity');
      q.textContent=formatQty(b*mult, q.getAttribute('data-unit'));
    });
  }
  const stepInc = BASE >= 4 ? 2 : 1;
  plusBtn.addEventListener('click',()=>{ if(current<MAX) updateServings(current+stepInc); });
  minusBtn.addEventListener('click',()=>{ if(current>MIN) updateServings(current-stepInc); });
  minusBtn.disabled = current<=MIN;
}